import { render } from "./doubleList.vue?vue&type=template&id=15ff859b&scoped=true"
import script from "./doubleList.vue?vue&type=script&lang=js"
export * from "./doubleList.vue?vue&type=script&lang=js"

import "./doubleList.vue?vue&type=style&index=0&id=15ff859b&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15ff859b"]])

export default __exports__